import PaymentStepsAccordion, { PaymentProcess } from "@components/integration/PaymentStepsAccordian";
import PaymentStepsCard, { PaymentSectionDataProps } from "@components/integration/PaymentStepsCard";
import AwardsSection from "@components/new-ui/AwardsSection";
import CaseStudyFeatureSection, { Feature } from "@components/new-ui/CaseStudyFeatureSection";
import ClientLogos, { LogoObject } from "@components/new-ui/ClientLogos";
import { container_classname } from "@components/new-ui/constants";
import CTASection from "@components/new-ui/CTASection";
import FAQSection, { FAQSectionProps } from "@components/new-ui/FAQSection";
import FeatureInfoCard, { FeatureInfo } from "@components/new-ui/IndustriesSection/FeatureInfoCard";
import Herosection, { HerosectionProps } from "@components/new-ui/IndustriesSection/Herosection";
import ProductSection, { Product } from "@components/new-ui/IndustriesSection/ProductSection";
import IntegrationSection from "@components/new-ui/IntegrationSection";
import NewLayout from "@components/new-ui/Layout";
import { GoArrowUpRight } from "react-icons/go";

interface PaymentGateWay {
    icon: string;
    title: string;
    descritpion: string;
    externalLink: string;
    subTitle: string;
}

const herosectionData: HerosectionProps = {
    chipTitle: "INTEGRATION",
    title: "WhatsApp CRM Integration — Connect Your Stack",
    description: "Sync every chat, automate replies, and watch deals close faster. Never miss another lead — deliver happy customers and skyrocketing conversions on WhatsApp.",
    primaryButtonText: "Start your free trial now",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/hero-image.png",
    backgroundColor: true,
};

const paymentGateWayData: PaymentGateWay[] = [
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/zoho.svg",
        title: "Zoho",
        subTitle: "CRM  ",
        descritpion: "Get a single source of truth with a two-way sync between Gallabox and Zoho CRM",
        externalLink: "https://gallabox.com/whatsapp-integrations/zoho",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/hubspot.svg",
        title: "Hubspot",
        subTitle: "CRM",
        descritpion: "Unify communication by integrating HubSpot with your WhatsApp Business account",
        externalLink: "https://gallabox.com/whatsapp-integrations/hubspot",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/leadsquared.svg",
        title: "Leadsquared",
        subTitle: "CRM",
        descritpion: "Interact with your CRM leads and customers on WhatsApp in a hassle-free way",
        externalLink: "https://gallabox.com/whatsapp-integrations/lead-squared",
    },

    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/odoo.svg",
        title: "Odoo",
        subTitle: "CRM",
        descritpion: "Send automated notifications and alerts to your Odoo contacts through WhatsApp",
        externalLink: "https://gallabox.com/whatsapp-integrations/odoo",
    },

    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/kylas.svg",
        title: "Kylas",
        subTitle: "CRM",
        descritpion: "Extend your Kylas CRM functionality to do more by connecting it with Gallabox",
        externalLink: "https://docs.gallabox.com/integration/customer-relationship-management-crm-systems/kylas",
    },
    {
        icon: "https://assets.gallabox.com/gb-home/integrations/crm/pipe-drive.svg",
        title: "Pipedrive",
        subTitle: "CRM",
        descritpion: "KONDESK is a CRM software with a one-stop solution to manage numerous features.",
        externalLink: "https://docs.gallabox.com/integration/customer-relationship-management-crm-systems/pipedrive",
    },
];

const featureInfo1: FeatureInfo = {
    mainTitle: "Start with the right fit",
    subtitle: "Not all integrations work the same way. Choose one that fits your business like a glove:",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/hubspot-connection.png",
    featureInfoList: [
        "Auto-convert WhatsApp chats into CRM leads with native Gallabox sync",
        "Get instant WhatsApp updates for orders, deliveries, and returns",
        "Match deal stages in your CRM to chat triggers. ",
    ],
};

const featureInfo2: FeatureInfo = {
    mainTitle: "Map data like a pro",
    subtitle: "Ever seen a WhatsApp message land in your CRM as “Unknown, Mumbai”? Avoid messy data by:",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/update-connection.png",
    description: "Use GenAI to your advantage and decrease sales cycles by a long shot",
    featureInfoList: [
        "Mandatory fields first (e.g., Zoho needs last names; Pipedrive requires deal stages)",
        "Using variables like order number or customer name for personalized auto-replies",
        "Setting up fallback responses for missing info: “Hey there! Mind sharing your email so we can help faster?",
    ],
};

const featureInfo3: FeatureInfo = {
    mainTitle: "Write like a human, not a bot",
    subtitle: "Your CRM knows the customer’s history — use it. Examples:",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/shoe-kickz.png",
    featureInfoList: [
        "Bad: “Your query is important to us.”",
        "Good: “Hi Raj! Your order #4502 ships tomorrow — track it here: [link]” Keep CTAs clear: “Reply ‘YES’ to confirm your appointment” works better than “Kindly acknowledge at your earliest convenience.”",
    ],
};

const featureInfo4: FeatureInfo = {
    mainTitle: "Respect the chat rhythm",
    subtitle: "Ever seen customers ghost you after too many messages? Keep chats natural: ",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/content-write.png",
    featureInfoList: [
        "Opt-ins: Only message users who’ve agreed to chat (e.g., post-purchase: “Can we WhatsApp your receipt?”)",
        "Batch replies: Group order updates into one message instead of spamming 5 texts",
        "Quiet hours: No promotional messages after 8 PM unless it’s urgent support.",
    ],
};

const featureInfo5: FeatureInfo = {
    mainTitle: "Design foolproof chat flows",
    subtitle: "Imagine a customer typing “I want to return my blue shoes”",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/chats.png",
    featureInfoList: [
        "Weak flow: Asks for order number → color → reason (3 steps)",
        "Smart flow: CRM auto-detects recent orders → suggests: “Return the Nike Blue Runner (ordered May 5)? Reply YES.",
    ],
};

const featureInfo6: FeatureInfo = {
    mainTitle: "Keep data clean behind the scenes",
    subtitle: "Turn messy data into actionable data points:",
    imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/clean-data.png",
    featureInfoList: [
        "Standardize phone numbers: +91 XXXX instead of 0XXXXX",
        "Format dates as DD-MM-YYYY (no 7/4/2024 confusion)",
        "Add CRM tags like “High-Intent” when a customer asks about pricing.",
    ],
};

const productCardData: Array<Product> = [
    {
        title: "Boost customer satisfaction",
        description: "Quick WhatsApp replies with their full history at your team’s fingertips.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/boost-branding.svg",
        headerBackground: true,
    },
    {
        title: "Centralised customer data",
        description: "Auto-save WhatsApp chats and contact information in your CRM — eliminating scattered info.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/inbox-unread.svg",
        headerBackground: true,
    },
    {
        title: "Real-time message tracking",
        description: "View every WhatsApp chat under the right customer profile for enhanced visibility.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/group-chat.svg",
        headerBackground: true,
    },
    {
        title: "Faster team collaboration ",
        description: "Get instant alerts on new messages so your team never misses a lead.",
        imageUrl: "https://assets.gallabox.com/gb-home/solution/solution-icons/share-circle.svg",
        headerBackground: true,
    },
];

const caseStudyFeatureCardData: Array<Feature> = [
    {
        mediaUrl: "https://assets.gallabox.com/gb-home/case-study/qatar-insurance-company.png",
        chiptitle: "FINANCE",
        title: "How Gallabox Helped Qatar Insurance Company Generate 2X More Leads on WhatsApp",
        statsInfoData: [
            { percentage: "31%", label: "Increase in team productivity" },
            { percentage: "102%", label: "Growth in lead generation" },
            { percentage: "2X", label: "Improvement in CSAT ratings" },
        ],
        url: "https://gallabox.com/case-study/juttichoo",
        cardColor: true,
    },
];

const defaultFAQData: FAQSectionProps = {
    title: "FAQs about WhatsApp CRM Integration",
    faqItems: [
        {
            question: "What is WhatsApp CRM integration?",
            answer: (
                <div>
                    Picture your sales team closing deals without app-hopping. WhatsApp CRM integration (Zoho/HubSpot) merges chat histories, auto-replies, and real-time
                    conversations into one dashboard. Track leads, send reminders, and nurture customers — all within WhatsApp. No missed messages, just smoother sales.
                </div>
            ),
        },
        {
            question: "Can I use the regular WhatsApp Business App with my CRM?",
            answer: (
                <>
                    Yes, Gallabox integrates WhatsApp Business chats with CRMs like Zoho and HubSpot. Automate lead/deal creation, map fields (names, numbers), and sync chat data
                    directly to your CRM dashboard. Manage interactions without switching apps — track conversations and update records in real-time.
                </>
            ),
        },
        {
            question: "Why should I bother integrating WhatsApp with my CRM?",
            answer: (
                <p>
                    Yes, your sales team shouldn’t chase leads across apps. Integrate WhatsApp with HubSpot or Zoho CRM via Gallabox — every chat auto-updates leads, slashes manual
                    entry, and centralizes customer histories. Respond faster, close smarter, and let CRM sync handle the heavy lifting.
                </p>
            ),
        },
        {
            question: "How does this integration make customer interactions better?",
            answer: (
                <div>
                    Yes, your team stops juggling apps and starts connecting. Every chat pops up with the customer’s full history: past orders, preferences, even unresolved
                    complaints. AI chatbots handle 24/7 queries and all WhatsApp data auto-syncs to your CRM for smarter follow-ups
                </div>
            ),
        },
        {
            question: "Native vs. third-party integration — what’s the difference?",
            answer: (
                <div>
                    DIY WhatsApp-CRM integration? Months of dev work. Gallabox? 5-minute setup. We handle sync, compliance and updates while your team sells. No coding, just
                    results.
                </div>
            ),
        },
        {
            question: "How do I integrate Gallabox with Zoho CRM to send WhatsApp messages directly from Zoho?",
            answer: (
                <>
                    Install Gallabox’s Zoho extension via their marketplace. Connect in Gallabox, copy-paste the access token, toggle contact sync (optional), and update. Send
                    WhatsApp messages straight from Zoho’s dashboard — contacts sync automatically.
                </>
            ),
        },
        {
            question: "Can I automate replies or use chatbots?",
            answer: (
                <p>
                    Yes! Create chatbots to handle FAQs, collect feedback, or recover abandoned carts. Set triggers (e.g., keywords like “discount” or inactivity) for auto-replies.
                    Bots escalate complex issues to your team—no coding needed. Users report cutting repetitive tasks by 50%.
                </p>
            ),
        },
        {
            question: "Will I see analytics or customer insights?",
            answer: (
                <p>
                    Yes, Gallabox’s dashboard tracks metrics like open rates, resolved chats, response times (TAT/FRT), and new contacts. Visualize trends with charts—message
                    types, conversation status, and web vs. WhatsApp interactions. Turn data into action: optimize workflows, speed up replies, and boost engagement.
                </p>
            ),
        },
        {
            question: "Is my data safe with WhatsApp CRM integration?",
            answer: (
                <p>
                    Yes. Gallabox uses WhatsApp’s end-to-end encryption, GDPR-compliant consent tools, and role-based access controls. Only authorized teams view customer chats,
                    with strict protocols to block unauthorized access or data leaks.
                </p>
            ),
        },

        {
            question: "I’m a small business — is this too fancy for me?",
            answer: (
                <p>
                    Gallabox keeps it simple. Start free (no setup fees) for solo ventures or scale with custom bots and analytics for teams. Built as a no-code platform, it helps
                    SMBs automate WhatsApp chats — no tech skills needed.
                </p>
            ),
        },
        {
            question: "Can I blast promotions or updates to my customers?",
            answer: (
                <p>
                    You bet — but without the spam. Use pre-approved WhatsApp templates (like “Order Shipped!” or “Flash Sale Alert”) to send personalized bulk messages. Gallabox
                    even lets you A/B test campaigns. Just avoid the “Buy now!!!” frenzy — WhatsApp hates spam as much as your customers do.
                </p>
            ),
        },
        {
            question: "How does personalization actually work?",
            answer: (
                <p>
                    Gallabox lets you insert variables into messages, tailoring content using CRM data like purchase history or location. Automate personalized broadcasts,
                    reminders, or support — no coding required.
                </p>
            ),
        },
        {
            question: "Which CRMs does Gallabox support?",
            answer: (
                <p>
                    Gallabox integrates with Zoho, Shopify, Shiprocket, and HubSpot. Salesforce integration is coming soon! For niche platforms, check our pricing page for
                    compatibility.
                </p>
            ),
        },
        {
            question: "Do I need a developer to set this up?",
            answer: (
                <p>
                    No, Gallabox is designed for humans, not coders. Our support team walks you through every step, from API keys to chatbot design. If you can send a WhatsApp
                    text, you can use our platform.
                </p>
            ),
        },
        {
            question: "How long until I’m up and running?",
            answer: (
                <p>
                    Most set-ups go live in 2 to 5 days. Simple setups? Under 24 hours (like this bakery: connected at 9 AM, automated order confirmations by lunch). Share your CRM
                    details and we’ll get you across your finish line.
                </p>
            ),
        },
        {
            question: "Can my team collaborate on customer chats?",
            answer: (
                <p>
                    Yes, you can assign chats, tag teammates (“@Raj, help with refund”), or add private notes (“VIP guest - set up a candlelight dinner table”). No more chaotic
                    email threads, spreadsheets, or “Who’s handling this?”. Just unified teamwork.
                </p>
            ),
        },

        {
            question: "What about WhatsApp message templates?",
            answer: (
                <p>
                    Gallabox supports pre-approved templates for appointments, payments, and delivery updates. Edit existing ones or create custom templates (requires Meta
                    approval, which typically takes minutes but can take up to 24 hours). Design within WhatsApp’s guidelines — Gallabox simplifies the process.
                </p>
            ),
        },

        {
            question: "What if WhatsApp changes its rules later?",
            answer: (
                <p>
                    We monitor Meta’s updates regularly and auto-adjust Gallabox’s offering accordingly. You’ll get email alerts, actionable tips (“Update your templates by
                    Friday!”). This way, your business-as-usual is not impacted, and it’s just smooth sailing ahead.
                </p>
            ),
        },
    ],
};

const defaultPaymentSectionData: PaymentSectionDataProps[] = [
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/integrations.png",
        title: "Go to integrations",
        description: "Go to Integrations → CRM in your Gallabox dashboard and pick your CRM platform.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/hubspot-integration.png",
        title: "Name your integration",
        description: "Give your integration a name and start the link-up.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/wa-business-message.png",
        title: "Authorize Access",
        description: "Click Sign in, sign in to your CRM, and grant permissions to link accounts.",
    },
    {
        imageUrl: "https://assets.gallabox.com/gb-home/integrations/crm/sync-contact.png",
        title: "Sync contacts automatically",
        description: "Toggle settings to auto-sync WhatsApp chats, log conversations, and get CRM notifications. ",
    },
];

const paymentStepsData: PaymentProcess = {
    title: "How to integrate Gallabox with your ecommerce store in 3 simple steps?",
    ProcessSteps: [
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/overview.gif",
            title: "Go to integrations",
            description: "Go to Integrations → CRM in your Gallabox dashboard and pick your CRM platform.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/configuration.gif",
            title: "Name your integration",
            description: "Give your integration a name and start the link-up.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/configuration.gif",
            title: "Authorize Access",
            description: "Click Sign in, sign in to your CRM, and grant permissions to link accounts.",
        },
        {
            imageUrl: "https://assets.gallabox.com/gb-home/integrations/ecommerce/configuration.gif",
            title: "Sync contacts automatically",
            description: "Toggle settings to auto-sync WhatsApp chats, log conversations, and get CRM notifications. ",
        },
    ],
};

const clientLogosData: LogoObject[] = [
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/biotique.svg", alt: "biotique", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/burgerman.svg", alt: "burgerman", width: 100, height: 0 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/designer-shake.svg", alt: "designer-shake", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/eter.svg", alt: "eter", width: 50, height: 50 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/glen.svg", alt: "glen", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/hugg.svg", alt: "hugg", width: 90, height: 0 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/kumaren-silks.svg", alt: "kumaren-silks", width: 120, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/lovegen.svg", alt: "lovegen", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/lux.svg", alt: "lux", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/royaloak.svg", alt: "royaloak", width: 100, height: 20 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/saravana-store.svg", alt: "saravana-stores", width: 120, height: 40 },
    { url: "https://assets.gallabox.com/gb-home/integrations/ecommerce/client-logo/seder.svg", alt: "seder", width: 90, height: 10 },
];

const Crm: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp CRM Integration — Connect HubSpot, Zoho, Salesforce & More"
            description="Integrate WhatsApp with your CRM in minutes. Sync contacts, automate messages & track conversations. Works with HubSpot, Zoho & more."
            canonical={"https://gallabox.com/integrations/crm/whatsapp"}
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/integrations/crm/wa-crm-og.png" }}
        >
            <Herosection herosection={herosectionData} />

            <section className="mt-20 mb-20">
                <div className="w-full">
                    <h3 className="text-base text-center font-normal py-2">Trusted by 10,000+ businesses</h3>
                    <ClientLogos logos={clientLogosData} />
                </div>
            </section>
            <section className={`${container_classname} mb-20`}>
                <h3 className="mb-5 md:text-6xl text-4xl">Why integrate your CRM platform with WhatsApp?</h3>
                <p>
                    Imagine every WhatsApp message—questions, orders, feedback—flowing straight into your CRM, auto-updating leads and syncing customer histories in real-time.
                    That’s the power of WhatsApp CRM integration. At Gallabox, we’ve helped hundreds of Indian businesses (just like yours) seamlessly integrate WhatsApp with all
                    the popular platforms — Zoho for sales teams, Shopify for online stores, and more.
                    <br />
                    <br />
                    The best part? You don&apos;t need to code. Let&apos;s walk through exactly how it works for each platform.
                </p>

                <section className="grid md:grid-cols-3 gap-6 mt-9">
                    {paymentGateWayData.map((paymentGate, idx) => {
                        return (
                            <a className="p-5 border border-gray-200 border-solid rounded-md hover:no-underline" key={idx} href={paymentGate.externalLink}>
                                <div className="flex gap-5 mb-9">
                                    <img src={paymentGate.icon} alt="" width={64} height={64} />
                                    <div className="flex flex-col gap-1">
                                        <p>{paymentGate.title}</p>
                                        <p>{paymentGate.subTitle}</p>
                                    </div>
                                </div>
                                <p>{paymentGate.descritpion}</p>
                                <GoArrowUpRight size={20} className="mt-5 ml-auto" />
                            </a>
                        );
                    })}
                </section>
            </section>

            <section className="lg:block hidden">
                <PaymentStepsCard title={"How to integrate WhatsApp with your CRM?"} paymentSectionData={defaultPaymentSectionData} />
            </section>
            <PaymentStepsAccordion paymentStepsData={paymentStepsData} />

            <section>
                <FeatureInfoCard {...featureInfo1} />
                <FeatureInfoCard {...featureInfo2} />
                <FeatureInfoCard {...featureInfo3} />
                <FeatureInfoCard {...featureInfo4} />
                <FeatureInfoCard {...featureInfo5} />
                <FeatureInfoCard {...featureInfo6} />
            </section>
            <ProductSection title="Benefits of WhatsApp CRM integration" productCardData={productCardData} />
            <section>
                <CaseStudyFeatureSection features={caseStudyFeatureCardData} backgroundColor={true} />
            </section>

            <FAQSection faqData={defaultFAQData} />

            <IntegrationSection isLight={true} />
            <AwardsSection />
            <CTASection title="Integrate your payment gateway with Gallabox now!" description="Be among the first to ride the WhatsApp automation wave" />
        </NewLayout>
    );
};

export default Crm;
